// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/ae56fa38f414f8f8f9d1.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"4e8c30da4078c577bbd2","191":"f1c36f32949f0d231b61","192":"78c6836efa31c85ad4a1"}[chunkId] + ".chunk.js";
};